module.exports = __webpack_public_path__ + "static/media/_olympics.ab40146c.png";